import React from "react";
import ReactDOM from "react-dom";
import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { FlagProvider } from '@unleash/proxy-client-react';
import "./index.css";
import App from "./App";
import { Spinner } from "./assets/spinner";
import config from "./config";


ReactDOM.render(
  <React.StrictMode>
      <FlagProvider config={config}>
          <App/>
      </FlagProvider>
    <Spinner />
  </React.StrictMode>,
  document.getElementById("root")
);